import { Button, Dialog, Switch, ToggleButton } from "@mui/material";
import { Employee } from "../../models/organisation/OrganisationModelV2"
import React, { useState } from "react";
import { t } from "i18next";
import { colorGrey } from "../../rsc/colors/colors";

type Props = {
    employee: Employee
    open: boolean
    setOpen: any
    onDismiss: (role: string, data?: any ) => void
}

export const EmployeeSettingsModal: React.FC<Props> = ({ open, setOpen, employee, onDismiss }: Props) => {

    const [permissionBid, setPermissionBid] = useState(employee.permissions?.bid_read && employee.permissions?.bid_write);

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2, padding: 2 }
            }}>
            <span className="font-28 bold">{employee.person.getFullName()} permissions</span>
            <div className="pempem-flex-row-rev marginTop8">
                <span style={{textTransform:'capitalize'}}>{t('bid')}</span>
                <Switch checked={permissionBid} onChange={() => setPermissionBid(!permissionBid)} />
            </div>
            {/* <div className="pempem-flex-row-rev">
                <span>{t('bid_write')}</span>
                <Switch checked={bidWrite} onChange={() => setBidWrite(!bidWrite)} />
            </div> */}
            <div className="pempem-flex-row-rev marginTop8" style={{width: '100%'}}>
                <Button variant="contained" style={{background: colorGrey()}} onClick={() => onDismiss('cancel')}>{t('cancel')}</Button>
                <Button variant="contained" onClick={() => onDismiss('save', {
                    bid_permission: permissionBid,
                })}>{t('save')}</Button>
            </div>
        </Dialog>
    );
}